<template>
  <div class="wrapper">
    <div class="container details">
      <div class="row"><div class="col-md-10"><h1>Statistik ton</h1></div></div>
      <div class="row" style="margin-top: 30px;width:1170px;max-width:100%">
        <div class="col-md-2 switchMonth" style="text-align:center">
          <label style="margin-bottom: 10px">{{chosenDateSpan}}</label>
          <br/>
          <InputSwitch v-model="dateChecked" />
        </div>
        <div class="col-md-2">
          <label for="startDate">Från</label><br/>
          <Calendar id="startDate" v-model="startDate" :locale="sv" dateFormat="yy-mm-dd" :manualInput="false" />
        </div>
        <div class="col-md-2">
          <label for="endDate">Till</label><br/>
          <Calendar id="endDate" v-model="endDate" :locale="sv" dateFormat="yy-mm-dd" :manualInput="false" />
        </div>
        <div class="col-md-2">
          <br/>
          <Button label="Sök" @click="getOrders()" />
        </div>
        <div class="col-md-1">
            <ProgressSpinner v-if="loading" style="width:50px;height:50px" strokeWidth="8" fill="#EEEEEE" animationDuration=".5s" />
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <p></p>
          <h2 style="margin-bottom:10px">Vetlanda</h2>
            <DataTable :value="vetArticlesAndTons" >
                <Column field="name" header="Artikel" footerStyle="text-align:left">
                </Column>
                <Column header="Totalt ton" bodyStyle="text-align:right" footerStyle="text-align:right">
                  <template #body="slotProps" >{{numberToLocaleString(parseFloat(slotProps.data.total))}}</template>
                  <template #footer><strong>Totalt ut från Vetlanda: {{getTotalAmount('VET')}}</strong> ton<br/><strong>Total saltsyra in Vetlanda: {{numberToLocaleString(vetHcl.total)}} ton</strong></template>
              </Column>
            </DataTable>
        </div>
        <div class="col-md-6">
          <Chart ref="primeChart" type="line" :data="vetData" :key="componentKeyVet" />
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
            <p></p>
            <h2 style="margin-bottom:10px">Sölvesborg</h2>
            <DataTable :value="solArticlesAndTons" >
                <Column field="name" header="Artikel" footerStyle="text-align:left">
                  <template #footer></template>
                </Column>
                <Column header="Totalt ton" bodyStyle="text-align:right" footerStyle="text-align:right">
                  <template #body="slotProps" >{{numberToLocaleString(parseFloat(slotProps.data.total))}}</template>
                  <template #footer><strong>Totalt ut från Sölvesborg: {{getTotalAmount('SOL')}}</strong> ton<br/><strong>Total saltsyra in Sölvesborg: {{numberToLocaleString(solHcl.total)}} ton</strong></template>
              </Column>
            </DataTable>
        </div>
         <div class="col-md-6">
          <Chart ref="primeChart2" type="line" :data="solData" :key="componentKeySol" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Row from 'primevue/row'
import ColumnGroup from 'primevue/columngroup'
import Button from 'primevue/button'
import moment from 'moment'
import Calendar from 'primevue/calendar'
import InputSwitch from 'primevue/inputswitch'
import Chart from 'primevue/chart'
import ProgressSpinner from 'primevue/progressspinner'

export default {
  name: 'FeralcostatsTon',
  components: {
    DataTable,
    Column,
    Button,
    moment,
    ColumnGroup,
    Calendar,
    InputSwitch,
    Chart,
    Row,
    ProgressSpinner
  },
  data () {
    return {
      componentKeyVet: 0,
      componentKeySol: 0,
      dateChecked: false,
      chosenDateSpan: 'År',
      startDate: null,
      endDate: null,
      loading: false,
      orders: [],
      articlesAndTons: [],
      vetArticlesAndTons: [],
      solArticlesAndTons: [],
      vetChartDataCurrent: [],
      vetChartDataPrevious: [],
      solChartDataCurrent: [],
      solChartDataPrevious: [],
      customerName: '',
      articles: [],
      vetHcl: {name: 'VET-R-HCl 34', total: 0.00},
      solHcl: {name: 'SOL-R-HCl 34', total: 0.00},
      sv: {
        firstDayOfWeek: 1,
        dayNames: ['Söndag', 'Måndag', 'Tisdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lördag'],
        dayNamesShort: ['Sön', 'Mån', 'Tis', 'Ons', 'Tor', 'Fre', 'Lör'],
        dayNamesMin: ['Sö', 'Må', 'Ti', 'On', 'To', 'Fr', 'Lö'],
        monthNames: [ 'Januari', 'Februari', 'Mars', 'April', 'Maj', 'Juni', 'Juli', 'Augusti', 'September', 'Oktober', 'November', 'December' ],
        monthNamesShort: [ 'Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec' ],
        today: 'Idag',
        clear: 'Rensa',
        dateFormat: 'yy-mm-dd',
        weekHeader: 'vk'
      },
      vetData: {
        labels: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
        datasets: [
          {
            label: 'Nuvarande period',
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            fill: false,
            borderColor: '#42A5F5',
            tension: 0.4
          },
          {
            label: 'Föregående period',
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            fill: false,
            borderDash: [5, 5],
            borderColor: '#FFA726',
            tension: 0.4
          }
        ]
      },
      solData: {
        labels: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
        datasets: [
          {
            label: 'Nuvarande period',
            data: [],
            fill: false,
            borderColor: '#42A5F5',
            tension: 0.4
          },
          {
            label: 'Föregående period',
            data: [],
            fill: false,
            borderDash: [5, 5],
            borderColor: '#FFA726',
            tension: 0.4
          }
        ]
      }
    }
  },
  async mounted () {
    this.setOneYear()
    this.articles = await this.getArticles()
  },
  computed: {
  },
  watch: {
    orders: function (newVal, oldVal) {
      this.orders = newVal
    },
    articles: function (newVal, oldVal) {
      this.articles = newVal
    },
    dateChecked: function (newVal, oldVal) {
      if (this.dateChecked) {
        this.chosenDateSpan = 'Månad'
        this.setMonth()
      } else {
        this.chosenDateSpan = 'År'
        this.setOneYear()
      }
    }
  },
  methods: {
    async getArticles () {
      let response = await this.$http.get('/api/objectdatas/objectdescriptionid/18')
      const articles = []
      this.articlesAndTons = []
      this.vetArticlesAndTons = []
      this.solArticlesAndTons = []
      this.vetHcl.total = 0.00
      this.solHcl.total = 0.00
      for (let article of response.data) {
        articles.push({id: article.id, name: article.data.articleId, short: article.data.descr})
        this.articlesAndTons.push({name: article.data.articleId, total: 0.00})
        if (article.data.articleId.startsWith('VET-') && !article.data.articleId.includes('HCl')) {
          this.vetArticlesAndTons.push({name: article.data.articleId, total: 0.00})
        }
        if (article.data.articleId.startsWith('SOL-') && !article.data.articleId.includes('HCl')) {
          this.solArticlesAndTons.push({name: article.data.articleId, total: 0.00})
        }
      }
      this.articlesAndTons.push({name: 'SOL-R-HCl 34', total: 0.00})
      this.vetArticlesAndTons.push({name: 'VET-R-HCl 34', total: 0.00})
      return articles
    },
    async getOrders () {
      await this.getArticles()
      this.loading = true
      let startDate = moment(this.startDate).format('YYYY-MM-DD')
      let endDate = moment(this.endDate).format('YYYY-MM-DD')
      let callApi = '/api/orders/by-daterange/between/' + startDate + '/' + endDate
      await this.$http
        .get(callApi)
        .then(response => {
          this.orders = response.data
          this.vetData.datasets[0].data = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
          this.vetChartDataCurrent = []
          this.vetChartDataPrevious = []
          this.solData.datasets[0].data = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
          this.solChartDataCurrent = []
          this.solChartDataPrevious = []
          for (let order of this.orders) {
            let totalDeliveredTon = 0.00
            for (let action of order.data.orderRows[0].actions) {
              if (action.name === 'Lossar' && action.amount !== undefined && action.amount !== '') {
                let itemId = ''
                if (order.type === 'feralcoIntern') {
                  if (order.data.productId === 'Saltsyra 34%' && order.data.deliveryPlaces === 'Vetlanda') {
                    itemId = 'VET-R-HCl 34'
                  } else if (order.data.productId === 'Saltsyra 34%' && order.data.deliveryPlaces === 'Sölvesborg') {
                    itemId = 'SOL-R-HCl 34'
                  } else if (order.data.productId === 'Plusjärn') {
                    itemId = 'SOL-P-FeCl3 314'
                  } else {
                    itemId = order.data.productId
                  }
                } else {
                  itemId = order.data.ItemId
                }
                let art = this.articlesAndTons.find(x => x.name === itemId)
                if (art !== undefined) {
                  art.total = art.total + parseFloat(action.amount)
                }
                let artVet = this.vetArticlesAndTons.find(x => x.name === itemId)
                if (artVet !== undefined && order.type === 'feralco') {
                  totalDeliveredTon = totalDeliveredTon + parseFloat(action.amount)
                  artVet.total = artVet.total + parseFloat(action.amount)
                }
                let artSOL = this.solArticlesAndTons.find(x => x.name === itemId)
                if (artSOL !== undefined) {
                  artSOL.total = artSOL.total + parseFloat(action.amount)
                }
                if (itemId === 'VET-R-HCl 34' && order.type === 'feralcoIntern') {
                  this.vetHcl.total = this.vetHcl.total + parseFloat(action.amount)
                }
                if (itemId === 'SOL-R-HCl 34' || itemId === 'SOL-R-HCl') {
                  this.solHcl.total = this.solHcl.total + parseFloat(action.amount)
                }
                if (itemId.startsWith('VET') && !itemId.includes('HCl')) {
                  let year = moment(action.endTime).year()
                  let formattedDate = moment(action.endTime).format('MM')
                  if (!isNaN(year)) {
                    let exists = this.vetChartDataCurrent.filter(obj => {
                      return obj.label === year + '-' + formattedDate
                    })
                    if (exists.length > 0 && this.vetChartDataCurrent.length > 0) {
                      exists[0].amount = exists[0].amount + parseFloat(action.amount)
                    } else {
                      this.vetChartDataCurrent.push({label: year + '-' + formattedDate, amount: parseFloat(action.amount)})
                    }
                  }
                }
                if (itemId.startsWith('SOL') && !itemId.includes('HCl')) {
                  let year = moment(action.endTime).year()
                  let formattedDate = moment(action.endTime).format('MM')
                  if (!isNaN(year)) {
                    let exists = this.solChartDataCurrent.filter(obj => {
                      return obj.label === year + '-' + formattedDate
                    })
                    if (exists.length > 0 && this.solChartDataCurrent.length > 0) {
                      exists[0].amount = exists[0].amount + parseFloat(action.amount)
                    } else {
                      this.solChartDataCurrent.push({label: year + '-' + formattedDate, amount: parseFloat(action.amount)})
                    }
                  }
                }
              }
            }
          }
          this.vetChartDataCurrent.sort(function (a, b) {
            return new Date(a.label) - new Date(b.label)
          })
          for (let obj of this.vetChartDataCurrent) {
            let month = parseInt(obj.label.split('-')[1])
            this.vetData.datasets[0].data[month - 1] = parseFloat(obj.amount.toFixed(2))
          }
          this.solChartDataCurrent.sort(function (a, b) {
            return new Date(a.label) - new Date(b.label)
          })
          for (let obj of this.solChartDataCurrent) {
            let month = parseInt(obj.label.split('-')[1])
            this.solData.datasets[0].data[month - 1] = parseFloat(obj.amount.toFixed(2))
          }
          this.getPreviousPeriodOrders()
        })
        .catch(error => console.log(error))
    },
    async getPreviousPeriodOrders () {
      let subtractInterval = 'years'
      if (this.chosenDateSpan === 'Månad') {
        subtractInterval = 'years'
      }
      let startDate = moment(this.startDate).subtract(1, subtractInterval).format('YYYY-MM-DD')
      let endDate = moment(this.endDate).subtract(1, subtractInterval).format('YYYY-MM-DD')
      let callApi = '/api/orders/by-daterange/between/' + startDate + '/' + endDate
      await this.$http
        .get(callApi)
        .then(response => {
          this.vetData.datasets[1].data = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
          this.vetChartDataPrevious = []
          this.solData.datasets[1].data = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
          this.solChartDataPrevious = []
          for (let order of response.data) {
            for (let action of order.data.orderRows[0].actions) {
              if (action.name === 'Lossar' && action.amount !== undefined && action.amount !== '') {
                let itemId = ''
                if (order.type === 'feralcoIntern') {
                  if (order.data.productId === 'Saltsyra 34%' && order.data.deliveryPlaces === 'Vetlanda') {
                    itemId = 'VET-R-HCl 34'
                  } else if (order.data.productId === 'Saltsyra 34%' && order.data.deliveryPlaces === 'Sölvesborg') {
                    itemId = 'SOL-R-HCl 34'
                  } else if (order.data.productId === 'Plusjärn') {
                    itemId = 'SOL-P-FeCl3 314'
                  } else {
                    itemId = order.data.productId
                  }
                } else {
                  itemId = order.data.ItemId
                }
                if (itemId.startsWith('VET') && !itemId.includes('HCl')) {
                  let year = moment(action.endTime).year()
                  let formattedDate = moment(action.endTime).format('MM')
                  if (!isNaN(year)) {
                    let exists = this.vetChartDataPrevious.filter(obj => {
                      return obj.label === year + '-' + formattedDate
                    })
                    if (exists.length > 0 && this.vetChartDataPrevious.length > 0) {
                      exists[0].amount = exists[0].amount + parseFloat(action.amount)
                    } else {
                      this.vetChartDataPrevious.push({label: year + '-' + formattedDate, amount: parseFloat(action.amount)})
                    }
                  }
                }
                if (itemId.startsWith('SOL') && !itemId.includes('HCl')) {
                  let year = moment(action.endTime).year()
                  let formattedDate = moment(action.endTime).format('MM')
                  if (!isNaN(year)) {
                    let exists = this.solChartDataPrevious.filter(obj => {
                      return obj.label === year + '-' + formattedDate
                    })
                    if (exists.length > 0 && this.solChartDataPrevious.length > 0) {
                      exists[0].amount = exists[0].amount + parseFloat(action.amount)
                    } else {
                      this.solChartDataPrevious.push({label: year + '-' + formattedDate, amount: parseFloat(action.amount)})
                    }
                  }
                }
              }
            }
          }
          this.vetChartDataPrevious.sort(function (a, b) {
            return new Date(a.label) - new Date(b.label)
          })
          for (let obj of this.vetChartDataPrevious) {
            let month = parseInt(obj.label.split('-')[1])
            this.vetData.datasets[1].data[month - 1] = parseFloat(obj.amount.toFixed(2))
          }
          this.solChartDataPrevious.sort(function (a, b) {
            return new Date(a.label) - new Date(b.label)
          })
          for (let currSolObj of this.solChartDataPrevious) {
            let month = parseInt(currSolObj.label.split('-')[1])
            this.solData.datasets[1].data[month - 1] = parseFloat(currSolObj.amount.toFixed(2))
          }
          this.componentKeyVet += 1
          this.componentKeySol += 1
          this.loading = false
        })
    },
    setOneYear () {
      let today = new Date()
      this.endDate = new Date()
      let oneYearBack = new Date(today.setDate(today.getDate() - 365))
      this.startDate = oneYearBack
    },
    setMonth () {
      let today = new Date()
      this.endDate = new Date()
      let oneMonthBack = new Date(today.setDate(today.getDate() - 31))
      this.startDate = oneMonthBack
    },
    getDate (theDate) {
      let formattedDate = moment(theDate).utc().format('YYYY-MM-DD')
      return formattedDate
    },
    getTotalAmount (place) {
      let total = 0.00
      if (place === 'VET') {
        for (let item of this.vetArticlesAndTons) {
          total = total + item.total
        }
      } else if (place === 'SOL') {
        for (let item of this.solArticlesAndTons) {
          total = total + item.total
        }
      }

      return this.numberToLocaleString(total)
    },
    numberToLocaleString (x) {
      return x.toLocaleString()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Statistics/FeralcoStatsTonnage.vue